import { useContext, useEffect, useState } from "react";

// Componentes
import SaldosdelCliente from './SaldodelClienteOri';
import UltimosMov from './UltimosMov';
import ProductosDeInversion from './ProductosDeInversion';
import Grafica from './Grafica';

// reactstrap components
import {
  Row,
  Col,
} from "reactstrap";

// Contextos
import AuthContext from '../context/autenticacion/authContext';
import SaldosContext from '../context/saldos/SaldosContext';

const Dashboard = () => {
  // Context de autenticación
  const authContext = useContext(AuthContext);
  const { usuarioAutenticado, status, CerrarSesion } = authContext;
  
  // Context de saldos
  const saldosContext = useContext(SaldosContext);
  const { saldos, consultarApiSaldo } = saldosContext;

  // Estado para recargar componentes hijos
  const [apiload, guardarApiLoad] = useState(true);
  // Cambia tras cada operación para que saldos y gráfica se vuelvan a cargar solos
  const [version, setVersion] = useState(0);

  // Función para refrescar datos
  const ApiLoad = () => {
    setVersion((v) => v + 1);
    guardarApiLoad(false);
    setTimeout(() => {
      guardarApiLoad(true);
    }, 50);
  };

  // Cargar saldos al montar el componente
  useEffect(() => {
    let isMounted = true;
    
    const loadSaldos = async () => {
      if (consultarApiSaldo && isMounted) {
        await consultarApiSaldo();
      }
    };
    
    loadSaldos();
    
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="content">
      {/* Tarjetas de saldos del cliente */}
      <SaldosdelCliente key={`s${version}`} saldos={saldos} />

      {/* Gráfica principal */}
      <Row>
        <Col xs="12">
          <Grafica key={`g${version}`} />
        </Col>
      </Row>

      {/* Grid de productos y movimientos */}
      <div className="grid-dashboard-template">
        <div className="grid-dash-element-1">
          <ProductosDeInversion apiload={apiload} ApiLoad={ApiLoad} />
        </div>

        <div className="grid-dash-element-2">
          <UltimosMov apiload={apiload} ApiLoad={ApiLoad} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;